import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=0bc8aca2&"
import script from "./VCarousel.vue?vue&type=script&setup=true&lang=js&"
export * from "./VCarousel.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./VCarousel.vue?vue&type=style&index=0&id=0bc8aca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports